import { Link } from "react-router-dom";
import { formatPrice, imageUrl } from "@/lib/api";

export default function ProductCard({ product }) {
    const img = imageUrl(product.images?.[0]);
    const img2 = imageUrl(product.images?.[1]);
    const discount = product.previousPrice ? Math.round((1 - product.price / product.previousPrice) * 100) : 0;
    const soldout = product.stock <= 0;
    return (
        <Link to={`/producto/${product.id}`} data-testid={`product-card-${product.id}`} className="group block">
            <div className="relative aspect-[4/5] rounded-md overflow-hidden bg-sandLight">
                {img && <img src={img} alt={product.name} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${img2 ? 'group-hover:opacity-0' : ''}`} loading="lazy" />}
                {img2 && <img src={img2} alt={product.name} className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500" loading="lazy" />}
                <div className="absolute top-3 left-3 flex flex-col gap-1.5">
                    {product.isNew && <span className="bg-ink text-bone text-[10px] px-2 py-1 rounded-full uppercase tracking-wide">Nuevo</span>}
                    {product.onSale && discount > 0 && <span className="bg-terracotta text-white text-[10px] px-2 py-1 rounded-full uppercase tracking-wide">-{discount}%</span>}
                    {soldout && <span className="bg-ink/80 text-bone text-[10px] px-2 py-1 rounded-full uppercase tracking-wide">Agotado</span>}
                </div>
            </div>
            <div className="mt-3">
                <p className="text-eyebrow text-ink/50">{product.brand}</p>
                <p className="text-sm text-ink mt-1 group-hover:underline underline-offset-4">{product.name}</p>
                <div className="flex items-baseline gap-2 mt-1">
                    <span className="text-sm text-ink">{formatPrice(product.price)}</span>
                    {product.previousPrice && <span className="text-xs text-ink/40 line-through">{formatPrice(product.previousPrice)}</span>}
                </div>
            </div>
        </Link>
    );
}
